import React from 'react';
// A simple tab shelf component for use in modals, with styling that matches the modal design.
export default function ModalTabShelf({
  tabs = [],
  activeKey = null,
  onChange = () => {},
  className = '',
  tabClassName = ''
}) {
  return (
    <div className={`modalTabShelf ${className}`.trim()}>
      {tabs.map((tab) => {
        const isActive = tab.key === activeKey;
        return (
          <div
            key={tab.key}
            className={`modalTab ${isActive ? 'active' : ''} ${tabClassName}`.trim()}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onChange(tab.key);
            }}
          >
            <span className="modalTabLabel">{tab.label}</span>
          </div>
        );
      })}
    </div>
  );
}
